<template>
  <div id="player-menu" class="right-side-menu workspace" ref="playerMenu">
    <div class="player-menu-content hide-scrollbar">
      <player-setup
        v-show="playerSetupWizardOpen"
        :serialNumber="serialNumber"
        :isOpened="playerSetupWizardOpen"
        :userPlan="userPlan"
        :isRestart="playerReconfiguration"
        v-on:PlayerSetupDialogClose="handleCloseSetupPlayerDialog"/>
      <template v-if="enableSetupPlayerAction">
        <!--- Show New Player If no Player selected Selection -->
        <template v-if="!playerSelection.length">
            <el-button
                class="new-player-btn cstm-btn-gradient width-125"
                @click="playerSetupWizardOpen = !playerSetupWizardOpen">
              {{$t('label.addPlayer')}}
            </el-button>
        </template>
      </template>

      <!-- Setup Properties -->
      <div v-if="showMenuItems" class="setup-properties">
        <div v-for="(optionProperty, indx) in setupProperties" :key="indx" :class="['setup-property', optionProperty.id, {'enable-setup': enableSetupPlayerAction}]">
          <!-- Serial Number -->
          <div v-if="playerSelection.length === 1 && optionProperty.id === setupPropertyIds.serialNumber" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>

            <div class="content serialNumber">
              <div class="presentation">{{playerSelection[0].serialNumber}}</div>
            </div>
          </div>

          <!-- Screen Orientation -->
          <div v-if="optionProperty.id === setupPropertyIds.screen && showScreenProp" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>

            <div class="content player-screen">
              <div class="presentation">
                <div v-if="showScreenContent" :class="['screen-type-wrapper']">
                  <el-button-group class="group-btn">
                    <el-button v-for="(item, indx) in screenOptions" :key="indx"
                      @click="handleScreenTypeClick(item)"
                      :class="[item.elClass, {'selected': (item.value === selectedScreen)}]">{{item.label}}
                    </el-button>
                  </el-button-group>
                </div>
                <div v-else :class="['default-val-content screen']">
                  <el-button-group :class="['group-btn default-value']">
                    <el-button @click="handleDefaultSetupValueOnClick(setupPropertyIds.screen)" :class="['selected', selectedScreen]"></el-button>
                  </el-button-group>
                </div>
              </div>
            </div>
          </div>

          <!-- Resolution -->
          <div v-if="optionProperty.id === setupPropertyIds.resolution && showResolutionOptionProp && !hideResolutionLessThanLedDimension" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>
            <div class="content player-resolution">
              <div class="presentation">
                <div v-if="showResolutionOptionContent" :class="['resolution-type-wrapper']">
                  <el-button-group class="group-btn">
                    <template v-for="(item, indx) in resolutionOptions[resolutionOptionsKey]">
                      <el-button v-if="item.visible" :key="indx"
                        @click="handleResolutionTypeOnClick(item)"
                        :class="[item.elClass, {'is-selected': (item.value === selectedResolution || (item.value === resolutionCUST && resolutionDefaultValContent === resolutionCUST))}]">{{item.label}}
                      </el-button>
                    </template>
                  </el-button-group>
                </div>
                <div v-else class="default-val-content" @click="handleDefaultSetupValueOnClick(setupPropertyIds.resolution)">{{resolutionDefaultValContent}}</div>
              </div>
            </div>
          </div>

          <!-- Timezone -->
          <div v-if="optionProperty.id === setupPropertyIds.timezone && showTimeZoneProp" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>
            <div class="content player-screen">
              <div class="presentation">
                <div v-if="showTimezoneContent" :class="['timezone-wrapper']">
                  <el-select
                    v-model="selectedTimezone"
                    :value-key="'value'"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="`* ${$t('label.pleaseEnterACity')}`"
                    :remote-method="handleTimezoneSearch"
                    :loading="isTimezoneSearching"
                    @change="handleTimezoneOnChange($event, 'dropDown')"
                    popper-class="indigo-dp-popper"
                    class="cstm-selectbox-grey">
                    <el-option v-for="(item, indx) in timeZones" :key="indx" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div v-else class="default-val-content timezone" @click="handleDefaultSetupValueOnClick(setupPropertyIds.timezone)">{{selectedTimezone}}</div>
              </div>
            </div>
          </div>

          <!-- Audio -->
          <div v-if="optionProperty.id === setupPropertyIds.audio && showAudioOptionProp" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>
            <div class="content player-audio">
              <div class="presentation">
                <div v-if="showAudioOptionContent" :class="['audio-wrapper']">
                  <el-button-group v-if="audioOptionsKey === 'optionsA'" class="group-btn">
                    <el-button v-for="(item, indx) in audioOptions[audioOptionsKey]" :key="indx"
                      @click="handleAudioOnChange(item, 'radioButton')"
                      :class="[item.elClass, {'is-selected': (item.value === selectedAudioVal)}]">{{item.label}}
                    </el-button>
                  </el-button-group>

                  <el-select v-if="audioOptionsKey === 'optionsB'" v-model="selectedAudioVal"
                    placeholder="Audio"
                    @change="handleAudioOnChange($event, 'dropDown')"
                    :popper-class="'cstm-selectbox-grey-popper player-audio-options'"
                    :value-key="'scheduleId'"
                    class="cstm-selectbox-grey">

                    <el-option v-for="(audio, audioKey) in audioOptions[audioOptionsKey]"
                      :key="audioKey" :label="audio.name"
                      :value="audio.id">
                    </el-option>
                  </el-select>
                </div>
                <div v-else class="default-val-content audio" @click="handleDefaultSetupValueOnClick(setupPropertyIds.audio)">{{audioDefaultValContent}}</div>
              </div>
            </div>
          </div>

          <!-- LED Tags -->
          <div v-if="optionProperty.id === setupPropertyIds.led && enableLEDPlayersTags && allLEDTags.length && playerSelection.length === 1" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>
            <div  class="content player-led-tag">
              <div class="presentation">
                <tags-menu-item
                  :key="'playerLEDTagsMenuItem'"
                  :tagsSummaryProp="allLEDTags"
                  :tagsProp="playerLEDTags"
                  :disabledEditTagItemsProp="['_allTags']"
                  :accessorComponentProp="'playerLEDTagsMenuItem'"
                  @tags-change="handleTagsMenuItemChange($event)">
                </tags-menu-item>
              </div>
            </div>
          </div>

          <!-- Player Tags -->
          <div v-if="optionProperty.id === setupPropertyIds.playerTag && enablePlayersTags" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name, 2)}}</div>
            <div class="content player-tag">
              <div class="presentation">
                <tags-menu-item
                  :key="'playerNormalTagsMenuItem'"
                  :tagsSummaryProp="tagsSummary"
                  :tagsProp="playerNormalTags"
                  :accessorComponentProp="'playerNormalTagsMenuItem'"
                  @tags-change="handleTagsMenuItemChange($event)">
                </tags-menu-item>
              </div>
            </div>
          </div>

          <!-- Player Playtime -->
          <div v-if="enablePlayTimes && playerSelection.length >= 1 && optionProperty.id === setupPropertyIds.playerPlaytime" class="setup-property-content section-wrapper">
            <div class="title">{{$t(optionProperty.name)}}</div>
            <div class="content playerPlaytime">
              <div class="playtime-form">
                <template v-if="showAutoLabelForPlaytime">
                  <div class="presentation auto">{{$t('label.auto')}}</div>
                </template>
                <template v-else>
                  <schedule-playtime-menu-item
                    ref="schedulePlaytime"
                    :parentAccessorComponentProp="'playersPageMenu'"
                    :mediaSelectionProp="[]"
                    :mediaPropertiesFormDataProp="mediaPropertiesForm"
                    @schedule-playtime-menu-item-change="handlePlaytimeChange($event, 'schedulePlaytimeMenuItem')">
                  </schedule-playtime-menu-item>
                </template>

              </div>
            </div>
          </div>

          <!-- Player Status -->
          <template v-if="optionProperty.id === setupPropertyIds.status && playerSelection.length === 1">
            <template v-if="(!playerSelection[0].online || ['disconnected'].indexOf(playerSelection[0].status) >= 0)"><!--offline-->
              <div class="setup-property-content section-wrapper">
                <div class="title">{{$t(optionProperty.name)}}</div>
                <div class="presentation">
                  <div class="content status">{{$t('label.offline')}}</div>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-if="playerSelection[0].status === 'unconfigured'" class="setup-property-content section-wrapper"><!--unconfigured-->
                <div class="title">{{$t(optionProperty.name)}}</div>
                <div class="presentation">
                  <div class="content status">{{$t('label.notConfigured')}}</div>
                </div>
              </div>
              <div v-else-if="playerSelection[0].status === 'failed'" class="setup-property-content section-wrapper"><!--failed-->
                <div class="title">{{$t(optionProperty.name)}}</div>
                <div class="presentation">
                  <div class="content status">{{$t('label.failed')}}</div>
                </div>
              </div>
              <div v-else-if="playerSelection[0].firmwareUpdate" class="setup-property-content section-wrapper"><!--firmwareUpdate-->
                <div class="title">{{$t(optionProperty.name)}}</div>
                <div class="content status">
                  <div class="presentation">
                    {{$t('label.firmwareUpdate')}}
                  </div>
                </div>
              </div>
              <div v-else-if="playerSelection[0].configPending" class="setup-property-content section-wrapper"><!--configPending-->
                <div class="title">{{$t(optionProperty.name)}}</div>
                <div class="content status">
                  <div class="presentation">
                    <template v-if="playerSelection[0].configPending.error">
                      {{$t('label.configError')}}
                      <div class="config-error-desc">{{playerSelection[0].configPending.error}}</div>
                    </template>
                    <template v-else-if="playerSelection[0].firmwareUpdate">
                      {{$t('label.firmwareUpdate')}}
                    </template>
                    <template v-else>
                      {{$t('label.configPending')}}
                    </template>
                  </div>
                </div>
              </div>
              <div v-else-if="playerSelection[0].degraded" class="setup-property-content section-wrapper">
                <div class="title"> {{$t(optionProperty.name)}} </div>
                <div class="content status">
                  <div class="presentation">
                    {{$t('label.slowSync')}}
                  </div>
                </div>
              </div>
            </template>
          </template>

          <!-- Setup Button -->
          <template v-if="enableSetupPlayerAction && (optionProperty.id === setupPropertyIds.setup && playerSelection.length === 1)">
            <div class="content firmwareVersion">
              <el-button @click="handleSetupMenuItemClick" class="setup-btn cstm-btn-gradient width-125">
                {{$t(optionProperty.name)}}
              </el-button>
            </div>
          </template>
        </div>

        <el-button v-if="editedProperties.length" @click="handleSubmitPlayerSetupData" id="submitPlayerSetupBtn" class="cstm-btn-gradient width-auto">{{$t('label.save')}}</el-button>
        <div class="mt-4" v-if="playerSelection.length === 1">
          <el-button @click="handleSetupMenuItemClick" class="cstm-btn-grey width-auto select-all-media white-background">
            {{ $t('label.reconfigure') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./player-menu.js"></script>
<style lang="scss" src="./player-menu.scss"></style>
